import React, {FC, ReactElement, useEffect, useState} from 'react';
import ConsumerApp from './ConsumerApp';
import {MsalAuthenticationTemplate, MsalProvider} from '@azure/msal-react';

import './MainApp.scss';
import {InteractionType, PublicClientApplication} from '@azure/msal-browser';
import OperatorApp from './OperatorApp';
import logo_white from './logo_white.png';
import {msalConfig} from './msalConfig';
import Tidio from "./utils/Tidio";


// const routes: RouteObject[] = [
//     {
//         path: '*',
//         element: <Home/>,
//         children: [
//             {path: 'transcription', element: <Transcription/>},
//             {path: 'billing', element: <Billing/>}
//         ]
//     }
// ]

const msalInstance = new PublicClientApplication(msalConfig);

const MainApp: FC<MainAppProps> = ({}): ReactElement => {
    // const [searchParams] = useSearchParams();
    const url = new URL(window.location.href);

    const [userCode, setUserCode] = useState<string>('');
    const [shareCode, setShareCode] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const pathParams = url.pathname.split('/');

        console.log('pathParams -> ', pathParams, pathParams?.length > 1)
        if (pathParams?.length > 1) {
            // const paramUsername = searchParams.get('username');
            //TODO validar que 'pathParams[1]' sea un código de usuario válido (4 digitos)
            const possibleUserCode = pathParams[1];
            const isANumber = !isNaN(Number(possibleUserCode));
            const isValidCode = possibleUserCode.length === 4;
            if (isANumber && isValidCode) {
                setUserCode(possibleUserCode);
                setShareCode(pathParams[2]);
            }
        }
        setLoading(false)
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <img src={logo_white} alt="Company Logo" className="logo"/>
            </div>
        );
    }

    if (userCode) {
        return (<ConsumerApp userCode={userCode} shareCode={shareCode}/>);
    }

    return (
        <>
            <Tidio/>
            <MsalProvider instance={msalInstance}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                    <OperatorApp/>
                </MsalAuthenticationTemplate>
            </MsalProvider>
        </>
    )
}


type MainAppProps = {}

export default MainApp;
